import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Col, DatePicker, Divider, Modal, Radio, Row} from 'antd';
import {FilterOutlined} from '@ant-design/icons'

const { RangePicker } = DatePicker;

export default function OrderFilterModal(props) {
    const [filterModalVisible, setFilterModalVisible] = useState(false);
    const [customDateSelection, setCustomDateSelection] = useState(true);
    const [paymentFilter, setPaymentFilter] = useState(null);
    const [fulfillmentFilter, setFulfillmentFilter] = useState(null);
    const [artTypeFilter, setArtTypeFilter] = useState(null);
    const [start, setStart] = useState(null);
    const [end, setEnd] = useState(null);

    const showModal = () => {
        setFilterModalVisible(true);
    }

    const handleOk = () => {
        if (props.onChange) {
            const filters = {...fulfillmentFilter, ...paymentFilter, ...artTypeFilter, ...start, ...end}
            if(Object.keys(filters).length === 0){
                props.onChange(null)
            }
            else{
                props.onChange(filters)
            }
        }
        setFilterModalVisible(false);
    }

    const handleCancel = () => {
        setFilterModalVisible(false);
    }

    const dateChange = (e) => {
        const today = new Date(Date.now());
        const todayStr = today.toLocaleDateString('en-CA');
        const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60* 60 * 1000);
        const sevenDaysAgoStr = sevenDaysAgo.toLocaleDateString('en-CA');
        const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
        const thirtyDaysAgoStr = thirtyDaysAgo.toLocaleDateString('en-CA');
        const calendarYear = new Date("1/1/23");
        const calendarYearStr = calendarYear.toLocaleDateString('en-CA');
        if(e.target.value === "None"){
            setCustomDateSelection(true);
            setStart(null)
            setEnd(null)
        }
        else if(e.target.value === "Last 7 Days"){
            setCustomDateSelection(true);
            setStart({start: {text: "start date: ", value:sevenDaysAgoStr}})
            setEnd({end: {text: "end date: ", value:todayStr}})
        }
        else if(e.target.value === "Last 30 Days"){
            setCustomDateSelection(true);
            setStart({start: {text: "start date: ", value:thirtyDaysAgoStr}})
            setEnd({end: {text: "end date: ", value:todayStr}})
        }
        else if(e.target.value ==="This Calendar Year"){
            setCustomDateSelection(true);
            setStart({start: {text: "start date: ", value:calendarYearStr}})
            setEnd({end: {text: "end date: ", value:todayStr}})
        }
        else{
            setCustomDateSelection(false);
        }
    }

    const fulfillmentChange = (checkedValues) => {
        if(checkedValues.join().length === 0){
            setFulfillmentFilter(null)
        }
        else{
            setFulfillmentFilter({fulfillmentFilter: {text: "fulfillment: ", value:checkedValues.join(), display_value:
                                    checkedValues.join()
                                    .replace("fulfilled", "Fulfilled")
                                    .replace("none", "Unfulfilled")
                                    .replace("canceled", "Canceled")}})
        }
    }

    const paymentChange = (checkedValues) => {
        if(checkedValues.join().length === 0){
            setPaymentFilter(null)
        }
        else{
            setPaymentFilter({paymentFilter: {text: "Payment/Verification: ", value:checkedValues.join(), display_value:
                                    checkedValues.join()
                                    .replace("none", "Unverified")
                                    .replace("none,", "")
                                    .replace("order-verified", "Verified")
                                    .replace("order-verified,", "")
                                    .replace("paid", "Paid")
                                    .replace("unPaid", "Unpaid")
                                    .replace("unpaid", "Unpaid")
                                    .replace("partially-paid", "Partially Paid")
                                    .replace("partially-Paid", "Partially Paid")
                                    .replace(",paid", ",Paid")
                                    .replace("refunded", "Refunded")}})
        }
    }

    const typeChange = (checkedValues) => {
        if(checkedValues.join().length === 0){
            setArtTypeFilter(null)
        }
        else{
            setArtTypeFilter({artTypeFilter: {text: "art Type: ", value:checkedValues.join()}})
        }
    }

    const customRangeChange = (range) => {
        const startDate = range[0].format("MM/DD/YYYY")
        const endDate = range[1].format("MM/DD/YYYY")
        setStart({start: {text: "start date: ", value:startDate}})
        setEnd({end: {text: "end date: ", value:endDate}})
    }
    
    return (
        <div>
            <Button 
                onClick={showModal}
                size='middle'
            >
                <FilterOutlined />
                Filter
            </Button>
            <Modal
                title='Filter Your Orders'
                visible={filterModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Checkbox.Group onChange={fulfillmentChange}>
                    <Row gutter = {[16, 16]}>
                        <Col span={24}>
                            <h3>Fulfillment Status</h3>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="fulfilled,payment-settled">Fulfilled</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="none,buyer-paid">Unfulfilled</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="canceled,order-canceled">Canceled</Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
                <Divider/>
                <Checkbox.Group onChange={paymentChange}>
                    <Row gutter = {[16, 16]}>
                        <Col span={24}>
                            <h3>Payment Status</h3>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="none">Order Unverified</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="order-verified">Order Verified</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="paid">Paid</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="none,order-verified,unpaid">Unpaid</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="refunded">Refunded</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="partially-paid">Partially Paid</Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
                <Divider/>
                <Radio.Group onChange={dateChange}>
                    <Row gutter = {[16, 16]}>
                        <Col span={24}>
                            <h3>Date</h3>
                        </Col>
                        <Col span={24}>
                            <Radio value="None">None</Radio>
                        </Col>
                        <Col span={24}>
                            <Radio value="Last 7 Days">Last 7 Days</Radio>
                        </Col>
                        <Col span={24}>
                            <Radio value="Last 30 Days">Last 30 Days</Radio>
                        </Col>
                        <Col span={24}>
                            <Radio value="This Calendar Year">This Calendar Year</Radio>
                        </Col>
                        <Col span={24}>
                            <Radio value="Custom Dates">Custom Dates</Radio>
                        </Col>
                        <Col span={24}>
                            <RangePicker disabled={customDateSelection} onChange={customRangeChange}/>
                        </Col>
                    </Row>
                </Radio.Group>
                <Divider/>
                <Checkbox.Group onChange={typeChange}>
                    <Row gutter = {[16, 16]}>
                        <Col span={24}>
                            <h3>Art Type</h3>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Original">Original</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Print">Print</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Commission">Commission</Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
            </Modal>
        </div>
    )
}
